import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import DesktopMenu from './desktop-menu/DesktopMenu';
import MobileMenu from './mobile-menu/MobileMenu';
import getNavigation from '../../../client/fetch/get-navigation';
import {
  addMediaQueryListener,
  isTabletPortrait,
} from '../../utils/device/identifyDevice';
import SEOLinks from './seo-links/SEOLinks';

export const fetchChildCategories = queryParams => ({ id }) =>
  getNavigation({ id, depth: 4, queryParams });

function Navigation({ mobileNavShown }) {
  const {
    categories,
    features: { displaySEOLinks },
    headerClientConfigQueryParameters,
  } = useContext(EnvVarsFeaturesContext);
  const [flyoutCategories, setFlyoutCategories] = useState({});

  const menus = [
    {
      id: 'shop-by-department',
      name: 'Shop by department',
      child: categories.child,
    },
  ];

  const fetch = fetchChildCategories(headerClientConfigQueryParameters);

  const fetchFlyoutCategories = async () => {
    const navCategories = await getNavigation({
      subset: 'FLYOUT',
      queryParams: headerClientConfigQueryParameters,
    });
    setFlyoutCategories(navCategories);
  };

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      isTabletPortrait() &&
      !flyoutCategories?.child
    ) {
      addMediaQueryListener(fetchFlyoutCategories);
    }
  }, []);

  return (
    <>
      {mobileNavShown ? (
        <MobileMenu menus={menus} fetchChildCategories={fetch} />
      ) : (
        <>
          <DesktopMenu
            child={
              flyoutCategories.child ? flyoutCategories.child : categories.child
            }
          />
          {displaySEOLinks && <SEOLinks categories={categories.child} />}
        </>
      )}
    </>
  );
}

Navigation.propTypes = {
  mobileNavShown: PropTypes.bool.isRequired,
};

export default Navigation;
